'use strict';
require('../../modules/esnext.symbol.observable');
var WrappedWellKnownSymbolModule = require('../../internals/well-known-symbol-wrapped');

module.exports = WrappedWellKnownSymbolModule.f('observable');
